<template>
    <div class="maintenance-container">
        <div class="maintenance-content">
            <div class="maintenance-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="#321575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                </svg>
            </div>
            
            <h1 class="maintenance-title">System Under Maintenance</h1>
            
            <div class="maintenance-message">
                <p v-if="message" v-html="message"></p>
                <p v-else>
                    We are currently performing scheduled maintenance to improve your experience. 
                    The system will be back online shortly.
                </p>
            </div>

            <div class="maintenance-schedule" v-if="startDate || endDate">
                <div class="schedule-item" v-if="startDate">
                    <span class="schedule-label">Maintenance Started:</span>
                    <span class="schedule-value">{{ startDate }}</span>
                </div>
                <div class="schedule-item" v-if="endDate">
                    <span class="schedule-label">Expected End:</span>
                    <span class="schedule-value">{{ endDate }}</span>
                </div>
            </div>

            <div class="maintenance-info">
                <div class="info-card">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="16" x2="12" y2="12"></line>
                        <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    </svg>
                    <p>Please check back later. We apologize for any inconvenience caused.</p>
                </div>
            </div>

            <div class="maintenance-contact">
                <p>For urgent queries, please contact:</p>
                <a href="mailto:admission@cu.ac.bd" class="contact-link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                    admission@cu.ac.bd
                </a>
            </div>

            <div class="maintenance-logo">
                <!-- <img src="@/assets/CU-Logo-CUadmin.png" alt="CU Logo" class="cu-logo" /> -->
                <p class="university-name">University of Chittagong</p>
                <p class="system-name">Admission System 2025-26</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MaintenanceMode',
    props: {
        message: {
            type: String,
            default: ''
        },
        startDate: {
            type: String,
            default: ''
        },
        endDate: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.maintenance-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ed 100%);
    padding: 20px;
}

.maintenance-content {
    max-width: 600px;
    width: 100%;
    text-align: center;
    background: white;
    border-radius: 24px;
    padding: 50px 40px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
}

.maintenance-icon {
    margin-bottom: 30px;
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.05);
        opacity: 0.8;
    }
}

.maintenance-title {
    font-size: 2rem;
    font-weight: 700;
    color: #321575;
    margin-bottom: 20px;
}

.maintenance-message {
    font-size: 1.1rem;
    color: #64748b;
    line-height: 1.7;
    margin-bottom: 30px;
}

.maintenance-schedule {
    background: #f8fafc;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 30px;
}

.schedule-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #e2e8f0;
}

.schedule-item:last-child {
    border-bottom: none;
}

.schedule-label {
    font-weight: 600;
    color: #475569;
}

.schedule-value {
    color: #321575;
    font-weight: 500;
}

.maintenance-info {
    margin-bottom: 30px;
}

.info-card {
    display: flex;
    align-items: center;
    gap: 15px;
    background: #fef3c7;
    border: 1px solid #fcd34d;
    border-radius: 12px;
    padding: 16px 20px;
    color: #92400e;
}

.info-card svg {
    flex-shrink: 0;
}

.info-card p {
    margin: 0;
    text-align: left;
    font-size: 0.95rem;
}

.maintenance-contact {
    margin-bottom: 30px;
}

.maintenance-contact p {
    color: #64748b;
    margin-bottom: 10px;
}

.contact-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #321575;
    text-decoration: none;
    font-weight: 600;
    padding: 10px 20px;
    background: #f1f5f9;
    border-radius: 8px;
    transition: all 0.3s ease;
}

.contact-link:hover {
    background: #321575;
    color: white;
}

.maintenance-logo {
    padding-top: 20px;
    border-top: 1px solid #e2e8f0;
}

.cu-logo {
    width: 80px;
    height: auto;
    margin-bottom: 10px;
}

.university-name {
    font-size: 1.1rem;
    font-weight: 600;
    color: #321575;
    margin-bottom: 4px;
}

.system-name {
    font-size: 0.9rem;
    color: #64748b;
    margin: 0;
}

@media (max-width: 576px) {
    .maintenance-content {
        padding: 30px 20px;
    }

    .maintenance-title {
        font-size: 1.5rem;
    }

    .maintenance-message {
        font-size: 1rem;
    }

    .schedule-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }

    .info-card {
        flex-direction: column;
        text-align: center;
    }

    .info-card p {
        text-align: center;
    }
}
</style>
